import { useState, useCallback, useDebugValue } from 'react';
import useAsyncEffect from './useAsyncEffect';

/**
 * @param {(isCancelled: () => boolean) => Promise<any>} fn 
 * @param {Array} deps 
 * @returns {{
 *   value: any;
 *   error: Error;
 *   status: string;
 * }}
 */
const useAsyncMemo = (fn, deps) => {
  const [ state, setState ] = useState({
    status: 'idle',
    value: null,
    error: null,
  });

  /**
   * Merges the passed state into the old state
   */
   const mergeState = useCallback((state) => {
    setState(ps => ({
      ...ps,
      ...state,
    }));
  }, []);

  useAsyncEffect(async (isCancelled) => {
    mergeState({status: 'pending'});

    try {
      const value = await fn(isCancelled);
      !isCancelled() && setState({status: 'success', value, error: null});
    } catch (error) {
      console.error(error);
      !isCancelled() && mergeState({status: 'error', error});
    }
  }, deps);

  useDebugValue(state);
  return state;
}

export default useAsyncMemo;